<template>
  <div class="enterSecretQuestion-screen">
    <div class="leftContent">
      <custom-header :img-number="14"></custom-header>
    </div>
    <div class="rightContent">
      <div class="headBlock">
        <custom-header />
      </div>
      <div class="wrap enterSecretQuestion_content">
        <div class="grow"></div>
        <h2 v-text="$ml.get('secretQuestionTitle')">Секретне запитання:</h2>
        <p class="question">{{ question }}</p>
        <p class="prompt">{{ questionTip }}</p>
        <login-input id="answer" name="answer" v-model="inputValue" class="textFieldAnswer" :is-not-valid="isNotValid" :valid-message="isNotValidMessage" :maxlength="30" @keydown.native.enter="nextScreen">
          <template slot="trailingIconSlot">
            <img :src="langIconSrc" />
          </template>
        </login-input>
        <!--type="inputLang"-->
        <!--:lang-icon-src="langIconSrc"-->
        <div class="grow"></div>
        <div class="bottom">
          <div class="left">
            <custom-button :button-text="$ml.get('back')" back :action="back"></custom-button>
          </div>
          <div class="right">
            <custom-button :button-text="$ml.get('next')" success :disabled="disabledButton" :action="nextScreen"></custom-button>
          </div>
        </div>
        <a class="link" v-text="$ml.get('restoreAccountAccess')" @click.prevent="$router.push({name: 'AccessRecoveryStart'})" href="/accessRecovery/">Відновити доступ до акаунту</a>
      </div>
    </div>
  </div>
</template>

<script>
import CustomHeader from '../../components/ui/custom-header';
import LoginInput from '../../components/ui/login-input';
import CustomButton from '../../components/ui/custom-button';
import Profile from '../../helpers/profile';
import {verifySecretCode as apiVerifySecretCode, getApiErrorMessage, resendSms} from '../../helpers/api';

export default {
  name: 'enterSecretQuestionPage',
  components: {CustomButton, LoginInput, CustomHeader},
  data() {
    return {
      inputValue: '',
      langIconSrc: '/static/flags/' + Profile.slanguage + '.png',
      isNotValid: false,
      isNotValidMessage: '',
      isNotValidTimout: null,
      question: Profile.squestion,
      questionTip: Profile.stips,
      isLoading: false,
    };
  },

  computed: {
    disabledButton: function() {
      return this.inputValue.length === 0 || this.isLoading;
    },
  },

  mounted: function() {
    Profile.setData({sanswer: ''});
  },

  methods: {
    nextScreen: function() {
      if (this.isLoading) return;
      this.isLoading = true;
      if (Profile.process === 'accessRecovery') {
        this.$router.push({name: 'AccessRecoveryInfoSelectLogin'});
      } else {
        apiVerifySecretCode(this.inputValue)
          .then(
            () => {},
            err => {
              if (err.status == 428) {
                this.$router.push('/login/infoSetAdditionalParams');
                return;
              }
              this.isNotValid = true;
              this.isNotValidMessage = getApiErrorMessage(err, {
                '401': this.$ml.get('secretQuestionErrorAnswer'),
                '409': this.$ml.get('errorSecretQuestionNotAllowed'),
              });
              clearTimeout(this.isNotValidTimout);
              this.isNotValidTimout = setTimeout(() => {
                this.isNotValid = false;
                this.isNotValidMessage = '';
              }, 3000);
              Profile.setData({
                sanswer: '',
                pincode: '',
              });
            }
          )
          .finally(() => {
            this.isLoading = false;
          });
      }
    },

    back: function() {
      Profile.setData({otpsend: true});
      // if (Profile.process === 'login') {
      //   resendSms();
      // }
      this.$router.back();
    },
  },
};
</script>
<style lang="scss">
.enterSecretQuestion_content {
  .trailingIcon {
    cursor: default !important;
  }
}
.rightContent .textFieldAnswer input.loginInput_text {
  padding-right: 54px;
  &:focus {
    padding-right: 54px;
  }
}
</style>
<style lang="scss" scoped>
.enterSecretQuestion_content {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 150px);
  justify-content: space-between;
  padding: 10% 6% 0;
}
.question {
  text-align: left;
  font-weight: 500;
  margin-bottom: 0;
}
.prompt {
  text-align: left;
  font-weight: 300;
  font-size: 12px;
  line-height: 16px;
  color: #7b7b7b;
}
.link {
  color: #5cd69b;
  font-weight: 300;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  margin: 12px 0;
}
.langImg {
  height: 54px;
  width: 38px;
  margin-top: -52px;
}
.bottom {
  .left {
    width: 40%;
    float: left;
  }
  .right {
    width: 56%;
    float: right;
  }
}

@media (min-width: 601px) and (max-width: 750px) {
  .question,
  .prompt {
    font-size: 18px;
    line-height: 24px;
  }
  .link {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }
  .enterSecretQuestion_content {
    height: calc(100vh - 160px);
    max-height: 700px;
  }
}
@media (min-width: 751px) {
  .question,
  .prompt {
    font-size: 18px;
    line-height: 24px;
  }
  .prompt {
    margin-top: 6px;
  }
  .link {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
  }
  .enterSecretQuestion_content {
    height: calc(100vh - 160px);
    max-height: 700px;
  }
}
</style>
